import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CompanyService {
  companyId: any;
  subject: Subject<any> = new Subject();
  private companyObservable: Observable<any>;

  constructor() {
    this.companyId = '';
    this.companyObservable = this.subject.asObservable();
  }

  setCompanyId(companyId): void {
    this.companyId = companyId;
    this.subject.next(companyId);
  }

  getCompanyId(): Observable<any> {
    this.subject.next(this.companyId);
    return this.companyObservable;
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/company.service.ts